import { FeatureName, OptimizelyFeatureNames } from "@lib/common-interfaces";
import { optimizelyStore } from "../optimizely-store";
import { featuresStore_DEPRECATED_DO_NOT_USE } from "../features-store";

/**
 * This will check whether a feature is enabled in either Optimizely or the legacy feature flags
 * store.
 *
 * USE WITH CAUTION: This could result in aberrant behavior, where a feature is globally disabled
 * in the legacy feature store but the user still gets the feature because of the Optimizely store,
 * for example.
 */
export function checkBothFeatureStores(optimizelyFeature: OptimizelyFeatureNames, legacyFeature: FeatureName): boolean {
  // We used separate parameter names, so we don't have to force people to use the same feature flag name
  // in each source.
  return optimizelyStore.isFeatureEnabled(optimizelyFeature) || featuresStore_DEPRECATED_DO_NOT_USE.isActive(legacyFeature);
}
